/* loa-enoch-bump-default.js — pre-select the 88-Book Ethiopian Bible order bump.
 *
 * Tim 2026-08-06: the bump must be pre-ticked on the Enoch landing page in ALL markets.
 *
 * WHAT THIS DOES: ticks the #en-bump checkbox on load. Verified behaviour: ticking the box does
 * NOT add anything to the cart by itself - the buy flow reads box.checked when the customer
 * presses Add to Cart and folds the bump variant into that single add. So this changes the
 * DEFAULT SELECTION, not the cart, and nothing is charged without an affirmative add-to-cart.
 *
 * WHY A SCRIPT AND NOT THE SECTION: the checkbox lives in sections/enoch-hero.liquid, a 65 KB
 * file. Rewriting it wholesale to flip one attribute risks corrupting a live funnel page; this
 * is surgical and trivially revertible.
 *
 * SAFETY: no-op on every page that has no #en-bump (the whole rest of the site). Wrapped in
 * try/catch. Only ever sets checked=true on first run, so a customer who unticks it stays
 * unticked - it never fights the user.
 *
 * Added 2026-08-06.
 */
(function () {
  try {
    if (window.__loaEnochBumpDefault) return;
    window.__loaEnochBumpDefault = true;

    var applied = false;

    function apply() {
      try {
        if (applied) return true;
        var box = document.getElementById('en-bump');
        if (!box) return false;          // not the Enoch page, or not rendered yet
        applied = true;                  // only ever act once, so the user can untick freely
        if (box.checked) return true;    // already selected - nothing to do
        box.checked = true;
        // Let any listener that mirrors the checkbox into page state see the change.
        try { box.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
        try { box.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
        return true;
      } catch (e) { return false; }
    }

    if (apply()) return;

    // The hero section can hydrate after this script runs; poll briefly, then give up.
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (apply() || tries > 40) clearInterval(timer);   // ~10s ceiling
    }, 250);

    document.addEventListener('DOMContentLoaded', apply);
  } catch (e) {}
})();
